import {styled} from '@mui/material/styles';
import React from 'react';
import {Typography} from '../Typography/Typography';
import {useHeaderState} from './HeaderStateContext';
import {HeaderBrandFontStack} from './types';
import {excludeComponentProps} from '../utils/excludeComponentProps';
import {headerCssClassNames} from './headerCssClassNames';

const StyledHeaderTitle = styled(Typography, {
    ...excludeComponentProps('brandFontStack', 'breakpoint')
})<{brandFontStack?: HeaderBrandFontStack}>(({
    theme, brandFontStack
}) => ({
    color: theme.tokens.FuelColorBrandPrimary,
    paddingLeft: theme.tokens.FuelSpacing6,
    marginRight: theme.tokens.FuelSpacing6,
    position: 'relative',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    ...brandFontStack === 'jdSans' && {
        fontFamily: theme.tokens.FuelFontFamilyJdSansProMedium,
        fontSize: theme.tokens.FuelFontSizeXl
    }
}));

export const HeaderTitle = React.forwardRef<HTMLElement, unknown>(({
    children, ...props
}, ref) => {
    const {
        title, brandFontStack
    } = useHeaderState();

    return (
        <StyledHeaderTitle
            {...props}
            brandFontStack={brandFontStack}
            className={headerCssClassNames.title}
            ref={ref}
            size='lg'
        >
            {title}
        </StyledHeaderTitle>
    );
});

HeaderTitle.displayName = 'HeaderTitle';
